import ROUTES from '../routes';
import Individual from '../hoc/individual/individual';
import IndividualList from '../hoc/individual/list';
import IndividualCustomerCreate from '../hoc/individual/create';
import IndividualCustomerInformation from '../hoc/individual/information';
import IndividualCustomerOverview from '../hoc/individual/overview/overview';
import OverviewCompaniesPanel from '../hoc/individual/overview/overview-companies-panel';
import CustomerStatementsTransactions from '../hoc/customers/statements/statements-transactions';
import AmlStatementsTransactions from '../hoc/customers/aml-statements/aml-statements-transactions';
import CustomerStatementsCards from '../hoc/customers/statements/statemenets-cards';
import IndividualCustomerAccounts from '../hoc/individual/accounts/accounts';
import CustomerAccountsTransactions from '../hoc/customers/accounts-statement/account-transactions';
import CustomerAccountsCardsTransactions from '../hoc/customers/accounts-statement/account-cards';
import CardTransaction from '../hoc/customers/accounts-statement/card-transaction';
import IndividualCustomerAml from '../hoc/individual/aml/aml';
import ProblemGLTransaction from '../hoc/customers/problem-transactions/problem-gl-transaction';
import ProblemInternalTransaction from '../hoc/customers/problem-transactions/problem-internal-transaction';
import ProblemInternalGeneralContent from '../hoc/customers/problem-transactions/problem-internal-general';
import ProblemInternalAmlContent from '../hoc/customers/problem-transactions/problem-internal-aml';
import ProblemInternalLogContent from '../hoc/customers/problem-transactions/problem-internal-log';
import ProblemInternalChatsContent from '../hoc/customers/problem-transactions/problem-internal-transaction-chats';
import ProblemInternalDocumentsContent from '../hoc/customers/problem-transactions/problem-internal-transaction-documents';
import ProblemIncomingTransaction from '../hoc/customers/problem-transactions/problem-incoming-transaction';
import ProblemIncomingGeneralContent from '../hoc/customers/problem-transactions/problem-incoming-general';
import ProblemIncomingOrderContent from '../hoc/customers/problem-transactions/problem-incoming-order';
import ProblemIncomingAmlContent from '../hoc/customers/problem-transactions/problem-incoming-aml';
import ProblemIncomingLogContent from '../hoc/customers/problem-transactions/problem-incoming-log';
import ProblemIncomingChangeLogContent from '../hoc/customers/problem-transactions/problem-incoming-change-log';
import ProblemIncomingTransactionChatsContent from '../hoc/customers/problem-transactions/problem-incoming-transaction-chats';
import ProblemIncomingTransactionDocumentsContent from '../hoc/customers/problem-transactions/problem-incoming-transaction-documents';
import ProblemOutgoingTransaction from '../hoc/customers/problem-transactions/problem-outgoing-transaction';
import ProblemOutgoingGeneralContent from '../hoc/customers/problem-transactions/problem-outgoing-general';
import ProblemOutgoingOrderContent from '../hoc/customers/problem-transactions/problem-outgoing-order';
import ProblemOutgoingAmlContent from '../hoc/customers/problem-transactions/problem-outgoing-aml';
import ProblemOutgoingLogContent from '../hoc/customers/problem-transactions/problem-outgoing-log';
import ProblemOutgoingChangeLogContent from '../hoc/customers/problem-transactions/problem-outgoing-change-log';
import ProblemOutgoingDocumentsContent from '../hoc/customers/problem-transactions/problem-outgoing-transaction-documents';
import ProblemOutgoingTransactionChatsContent from '../hoc/customers/problem-transactions/problem-outgoing-transaction-chats';
import ProblemExchangeTransaction from '../hoc/customers/problem-transactions/problem-exchange-transaction';
import ProblemExchangeGeneralContent from '../hoc/customers/problem-transactions/problem-exchange-transaction-general';
import ProblemExchangeLog from '../hoc/customers/problem-transactions/problem-exchange-transaction-log';
import ProblemExchangeChangeLog from '../hoc/customers/problem-transactions/problem-exchange-transaction-change-log';
import ProblemExchangeChats from '../hoc/customers/problem-transactions/problem-exchange-transaction-chats';
import ProblemNostroTransaction from '../hoc/customers/problem-transactions/problem-nostro-transaction';
import ProblemNostroGeneralContent from '../hoc/customers/problem-transactions/problem-nostro-transaction-general';
import ProblemNostroLog from '../hoc/customers/problem-transactions/problem-nostro-transaction-log';
import ProblemNostroChangeLog from '../hoc/customers/problem-transactions/problem-nostro-transaction-change-log';
import CustomerDocuments from '../hoc/customers/documents/general';
import CustomerDocumentInfo from '../hoc/customers/documents/info';
import CustomerDocumentCreate from '../hoc/customers/documents/create';
import CustomerStatistic from '../hoc/customers/statistic/statistic';
import IndividualCustomerCards from '../hoc/individual/cards/cards';
import CustomerTariffs from '../hoc/customers/tariffs/tariffs';
import CustomerCreateFee from '../hoc/customers/tariffs/fee-form';
import CustomerTransactionFromFee from '../hoc/customers/tariffs/transaction-from-fee';
import CustomerOrderCard from '../hoc/individual/cards/order';
import IncomingTransactionWarnings from '../hoc/customers/problem-transactions/problem-incoming-transaction-warnings';
import OutgoingTransactionWarnings from '../hoc/customers/problem-transactions/problem-outgoing-transaction-warnings';
import InternalTransactionWarnings from '../hoc/customers/problem-transactions/problem-internal-transaction-warnings';
import InternalTransactionChangeLogs from '../hoc/customers/problem-transactions/problem-internal-transactions-change-log';
import StatementGLTransaction from '../hoc/customers/statements/transactions/gl';
import CustomerAgreement from '../hoc/customers/documents/agreement-sidepanel';
import Beneficiaries from '../hoc/customers/beneficiaries/beneficiaries';
import Beneficiary from '../hoc/customers/beneficiaries/beneficiary';
import BeneficiaryContract from '../hoc/customers/beneficiaries/beneficiary-contract';
import ExternalAccounts from '../hoc/customers/external/external';
import CreateCustomersExternalAccount from '../hoc/customers/external/create';
import ExternalAccountForm from '../hoc/customers/external/item';
import IndividualCustomerDevices from '../hoc/individual/devices/devices';
import IndividualCustomerSecurity from '../hoc/individual/security/security';
import IndividualCustomerSecurityLocks from '../hoc/individual/security/locks-list';
import IndividualCustomerSecurityLockForm from '../hoc/individual/security/locks-form';
import IndividualCustomerSecurityLogs from '../hoc/individual/security/logs-list';
import IndividualCustomerSecurityLogForm from '../hoc/individual/security/logs-form';
import IndividualCustomerDeviceItem from '../hoc/individual/devices/device-item';
import ExhcangeTransactionComments from '../hoc/customers/problem-transactions/problem-exchange-transaction-comments';
import NostroTransactionComments from '../hoc/customers/problem-transactions/problem-nostro-transcation-comments';
import InternalTransactionComments from '../hoc/customers/problem-transactions/problem-internal-transaction-comments';
import IncomingTransactionComments from '../hoc/customers/problem-transactions/problem-incoming-transaction-comments';
import OutgoingTransactionComments from '../hoc/customers/problem-transactions/problem-outgoing-transacation-comments';
import CustomerExternalAccounts from '../hoc/customers/external/accounts';
import CustomerLinkedClients from '../hoc/customers/external/linked-clients';
import LinkCustomerForm from '../hoc/customers/external/link-customer';

import { CustomerType, OrganizationType } from '../hoc/customers/types';

const IndividualCustomers = {
  path: ROUTES.CUSTOMERS_INDIVIDUAL,
  element: <Individual />,
  children: [
    {
      path: ROUTES.CUSTOMERS_INDIVIDUAL_LIST,
      element: <IndividualList />,
      children: [
        {
          path: ROUTES.CUSTOMERS_INDIVIDUAL_CREATE,
          element: <IndividualCustomerCreate />,
        },
      ],
    },
    {
      path: ROUTES.CUSTOMERS_INDIVIDUAL_PAGE,
      element: <IndividualCustomerInformation />,
      children: [
        {
          path: ROUTES.CUSTOMERS_INDIVIDUAL_OVERVIEW,
          element: <IndividualCustomerOverview />,
          children: [
            {
              path: ROUTES.CUSTOMERS_INDIVIDUAL_OVERVIEW_COMPANIES,
              element: <OverviewCompaniesPanel />,
            },
            {
              path: ROUTES.CUSTOMERS_INDIVIDUAL_OVERVIEW_TRANSACTIONS,
              element: (
                <CustomerStatementsTransactions
                  customerType={CustomerType.INDIVIDUAL}
                />
              ),
              children: [
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_OVERVIEW_COMPANIES,
                  element: <OverviewCompaniesPanel />,
                },
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_OVERVIEW_TRANSACTIONS_GL,
                  element: (
                    <StatementGLTransaction
                      customerType={CustomerType.INDIVIDUAL}
                    />
                  ),
                },
              ],
            },
            {
              path: ROUTES.CUSTOMERS_INDIVIDUAL_OVERVIEW_CARDS,
              element: (
                <CustomerStatementsCards
                  customerType={CustomerType.INDIVIDUAL}
                />
              ),
              children: [
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_OVERVIEW_CARDS_COMPANIES,
                  element: <OverviewCompaniesPanel />,
                },
              ],
            },
          ],
        },
        {
          path: ROUTES.CUSTOMERS_INDIVIDUAL_ACCOUNTS,
          element: <IndividualCustomerAccounts />,
          children: [
            {
              path: ROUTES.CUSTOMERS_INDIVIDUAL_ACCOUNTS_TRANSACTIONS,
              element: (
                <CustomerAccountsTransactions
                  customerType={CustomerType.INDIVIDUAL}
                  accountsPage
                />
              ),
              children: [
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_ACCOUNTS_TRANSACTION_GL,
                  element: (
                    <StatementGLTransaction
                      customerType={CustomerType.INDIVIDUAL}
                      accountsPage
                    />
                  ),
                },
              ],
            },
            {
              path: ROUTES.CUSTOMERS_INDIVIDUAL_ACCOUNTS_CARDS,
              element: (
                <CustomerAccountsCardsTransactions
                  customerType={CustomerType.INDIVIDUAL}
                  page="accounts"
                />
              ),
              children: [
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_ACCOUNTS_CARD_TRANSACTION,
                  element: (
                    <CardTransaction
                      backPath={ROUTES.CUSTOMERS_INDIVIDUAL_ACCOUNTS_CARDS}
                    />
                  ),
                },
              ],
            },
          ],
        },
        {
          path: ROUTES.CUSTOMERS_INDIVIDUAL_EXTERNAL_ACCOUNTS,
          element: <ExternalAccounts type={OrganizationType.INDIVIDUAL} />,
          children: [
            {
              path: ROUTES.CUSTOMERS_INDIVIDUAL_EXTERNAL_ACCOUNTS_LIST,
              element: (
                <CustomerExternalAccounts type={OrganizationType.INDIVIDUAL} />
              ),
              children: [
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_EXTERNAL_ACCOUNTS_CREATE,
                  element: (
                    <CreateCustomersExternalAccount
                      type={OrganizationType.INDIVIDUAL}
                    />
                  ),
                },

                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_EXTERNAL_ACCOUNTS_ITEM,
                  element: (
                    <ExternalAccountForm type={CustomerType.INDIVIDUAL} />
                  ),
                },
              ],
            },
            {
              path: ROUTES.CUSTOMERS_INDIVIDUAL_EXTERNAL_LINKED_CLIENTS,
              element: (
                <CustomerLinkedClients type={OrganizationType.INDIVIDUAL} />
              ),
              children: [
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_EXTERNAL_LINKED_CLIENTS_CREATE,
                  element: (
                    <LinkCustomerForm type={OrganizationType.INDIVIDUAL} />
                  ),
                },
              ],
            },
          ],
        },
        {
          path: ROUTES.CUSTOMERS_INDIVIDUAL_AML,
          element: <IndividualCustomerAml />,
          children: [
            {
              path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTIONS,
              element: (
                <AmlStatementsTransactions
                  customerType={CustomerType.INDIVIDUAL}
                />
              ),
              children: [
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_GL,
                  element: (
                    <ProblemGLTransaction
                      backPath={ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTIONS}
                    />
                  ),
                },
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_EXCHANGE,
                  element: (
                    <ProblemExchangeTransaction
                      backPath={ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTIONS}
                      matchPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_EXCHANGE
                      }
                      generalPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_EXCHANGE_GENERAL
                      }
                      logPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_EXCHANGE_LOG
                      }
                      changeLogPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_EXCHANGE_CHANGE_LOG
                      }
                      chatPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_EXCHANGE_CHATS
                      }
                      commentsPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_EXCHANGE_COMMENTS
                      }
                    />
                  ),
                  children: [
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_EXCHANGE_GENERAL,
                      element: <ProblemExchangeGeneralContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_EXCHANGE_LOG,
                      element: <ProblemExchangeLog />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_EXCHANGE_CHANGE_LOG,
                      element: <ProblemExchangeChangeLog />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_EXCHANGE_CHATS,
                      element: <ProblemExchangeChats />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_EXCHANGE_COMMENTS,
                      element: <ExhcangeTransactionComments />,
                    },
                  ],
                },
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_NOSTRO,
                  element: (
                    <ProblemNostroTransaction
                      backPath={ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTIONS}
                      matchPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_NOSTRO
                      }
                      generalPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_NOSTRO_GENERAL
                      }
                      logPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_NOSTRO_LOG
                      }
                      changeLogPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_NOSTRO_CHANGE_LOG
                      }
                      commentsPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_NOSTRO_COMMENTS
                      }
                    />
                  ),
                  children: [
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_NOSTRO_GENERAL,
                      element: <ProblemNostroGeneralContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_NOSTRO_LOG,
                      element: <ProblemNostroLog />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_NOSTRO_CHANGE_LOG,
                      element: <ProblemNostroChangeLog />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_NOSTRO_COMMENTS,
                      element: <NostroTransactionComments />,
                    },
                  ],
                },
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INTERNAL,
                  element: (
                    <ProblemInternalTransaction
                      matchPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INTERNAL
                      }
                      warningPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INTERNAL_WARNING
                      }
                      generalPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INTERNAL_GENERAL
                      }
                      amlPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INTERNAL_AML
                      }
                      logPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INTERNAL_LOG
                      }
                      changeLogPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INTERNAL_CHANGE_LOG
                      }
                      chatPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INTERNAL_CHATS
                      }
                      documentPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INTERNAL_DOCUMENTS
                      }
                      commentsPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INTERNAL_COMMENTS
                      }
                      backPath={ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTIONS}
                    />
                  ),
                  children: [
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INTERNAL_GENERAL,
                      element: <ProblemInternalGeneralContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INTERNAL_AML,
                      element: <ProblemInternalAmlContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INTERNAL_LOG,
                      element: <ProblemInternalLogContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INTERNAL_WARNING,
                      element: <InternalTransactionWarnings />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INTERNAL_CHANGE_LOG,
                      element: <InternalTransactionChangeLogs />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INTERNAL_CHATS,
                      element: <ProblemInternalChatsContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INTERNAL_DOCUMENTS,
                      element: <ProblemInternalDocumentsContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INTERNAL_COMMENTS,
                      element: <InternalTransactionComments />,
                    },
                  ],
                },
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INCOMING,
                  element: (
                    <ProblemIncomingTransaction
                      matchPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INCOMING
                      }
                      backPath={ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTIONS}
                      generalPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INCOMING_GENERAL
                      }
                      amlPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INCOMING_AML
                      }
                      orderPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INCOMING_ORDER
                      }
                      logPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INCOMING_LOG
                      }
                      changeLogPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INCOMING_CHANGE_LOG
                      }
                      warningPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INCOMING_WARNINGS
                      }
                      chatPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INCOMING_CHATS
                      }
                      documentPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INCOMING_DOCUMENTS
                      }
                      commentsPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INCOMING_COMMENTS
                      }
                    />
                  ),
                  children: [
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INCOMING_GENERAL,
                      element: <ProblemIncomingGeneralContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INCOMING_ORDER,
                      element: <ProblemIncomingOrderContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INCOMING_AML,
                      element: <ProblemIncomingAmlContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INCOMING_LOG,
                      element: <ProblemIncomingLogContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INCOMING_CHANGE_LOG,
                      element: <ProblemIncomingChangeLogContent />,
                    },

                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INCOMING_WARNINGS,
                      element: <IncomingTransactionWarnings />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INCOMING_CHATS,
                      element: <ProblemIncomingTransactionChatsContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INCOMING_DOCUMENTS,
                      element: <ProblemIncomingTransactionDocumentsContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_INCOMING_COMMENTS,
                      element: <IncomingTransactionComments />,
                    },
                  ],
                },
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING,
                  element: (
                    <ProblemOutgoingTransaction
                      matchPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING
                      }
                      backPath={ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTIONS}
                      generalPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING_GENERAL
                      }
                      amlPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING_AML
                      }
                      orderPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING_ORDER
                      }
                      logPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING_LOG
                      }
                      warningPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING_WARNINGS
                      }
                      chatPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING_CHATS
                      }
                      documentPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING_DOCUMENTS
                      }
                      changeLogPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING_CHANGE_LOG
                      }
                      commentsPath={
                        ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING_COMMENTS
                      }
                    />
                  ),
                  children: [
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING_GENERAL,
                      element: <ProblemOutgoingGeneralContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING_ORDER,
                      element: <ProblemOutgoingOrderContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING_AML,
                      element: <ProblemOutgoingAmlContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING_LOG,
                      element: <ProblemOutgoingLogContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING_CHANGE_LOG,
                      element: <ProblemOutgoingChangeLogContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING_WARNINGS,
                      element: <OutgoingTransactionWarnings />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING_CHATS,
                      element: <ProblemOutgoingTransactionChatsContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING_DOCUMENTS,
                      element: <ProblemOutgoingDocumentsContent />,
                    },
                    {
                      path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_TRANSACTION_OUTGOING_COMMENTS,
                      element: <OutgoingTransactionComments />,
                    },
                  ],
                },
              ],
            },
            {
              path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_CARDS,
              element: (
                <CustomerAccountsCardsTransactions
                  customerType={CustomerType.INDIVIDUAL}
                  page="aml"
                />
              ),
              children: [
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_AML_CARD_TRANSACTION,
                  element: (
                    <CardTransaction
                      backPath={ROUTES.CUSTOMERS_INDIVIDUAL_AML_CARDS}
                    />
                  ),
                },
              ],
            },
          ],
        },
        {
          path: ROUTES.CUSTOMERS_INDIVIDUAL_STATISTICS,
          element: <CustomerStatistic customerType={CustomerType.INDIVIDUAL} />,
        },
        {
          path: ROUTES.CUSTOMERS_INDIVIDUAL_DOCUMENTS,
          element: <CustomerDocuments customerType={CustomerType.INDIVIDUAL} />,
          children: [
            {
              path: ROUTES.CUSTOMERS_INDIVIDUAL_AGREEMENT,
              element: (
                <CustomerAgreement customerType={CustomerType.INDIVIDUAL} />
              ),
            },
            {
              path: ROUTES.CUSTOMERS_INDIVIDUAL_DOCUMENTS_INFO,
              element: (
                <CustomerDocumentInfo customerType={CustomerType.INDIVIDUAL} />
              ),
            },
            {
              path: ROUTES.CUSTOMERS_INDIVIDUAL_DOCUMENTS_ADD,
              element: (
                <CustomerDocumentCreate
                  customerType={CustomerType.INDIVIDUAL}
                />
              ),
            },
          ],
        },
        {
          path: ROUTES.CUSTOMERS_INDIVIDUAL_CARDS,
          element: <IndividualCustomerCards />,
          children: [
            {
              path: ROUTES.CUSTOMERS_INDIVIDUAL_CARDS_TRANSACTION,
              element: (
                <CardTransaction backPath={ROUTES.CUSTOMERS_INDIVIDUAL_CARDS} />
              ),
            },
            {
              path: ROUTES.CUSTOMERS_INDIVIDUAL_CARDS_ORDER,
              element: <CustomerOrderCard />,
            },
            {
              path: ROUTES.CUSTOMERS_INDIVIDUAL_CARDS_EDIT,
              element: <CustomerOrderCard />,
            },
          ],
        },
        {
          path: ROUTES.CUSTOMERS_INDIVIDUAL_TARIFFS,
          element: <CustomerTariffs customerType={CustomerType.INDIVIDUAL} />,
          children: [
            {
              path: ROUTES.CUSTOMERS_INDIVIDUAL_TARIFFS_FEE,
              element: (
                <CustomerCreateFee customerType={CustomerType.INDIVIDUAL} />
              ),
              children: [
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_TARIFFS_CREATE_TRANSACTION,
                  element: (
                    <CustomerTransactionFromFee
                      customerType={CustomerType.INDIVIDUAL}
                    />
                  ),
                },
              ],
            },
          ],
        },
        {
          path: ROUTES.CUSTOMERS_INDIVIDUAL_BENEFICIARIES,
          element: <Beneficiaries type={CustomerType.INDIVIDUAL} />,
          children: [
            {
              path: ROUTES.CUSTOMERS_INDIVIDUAL_BENEFICIARY,
              element: <Beneficiary type={CustomerType.INDIVIDUAL} />,
              children: [
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_BENEFICIARY_CONTRACT,
                  element: (
                    <BeneficiaryContract type={CustomerType.INDIVIDUAL} />
                  ),
                },
              ],
            },
          ],
        },

        {
          path: ROUTES.CUSTOMERS_INDIVIDUAL_SECURITY,
          element: <IndividualCustomerSecurity />,
          children: [
            {
              path: ROUTES.CUSTOMERS_INDIVIDUAL_SECURITY_DEVICES,
              element: <IndividualCustomerDevices />,
              children: [
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_SECURITY_DEVICES_CREATE,
                  element: (
                    <IndividualCustomerSecurityLockForm type="devices" />
                  ),
                },
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_SECURITY_DEVICES_ITEM,
                  element: <IndividualCustomerDeviceItem />,
                },
              ],
            },
            {
              path: ROUTES.CUSTOMERS_INDIVIDUAL_SECURITY_LOCKS,
              element: <IndividualCustomerSecurityLocks />,
              children: [
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_SECURITY_LOCKS_CREATE,
                  element: <IndividualCustomerSecurityLockForm type="locks" />,
                },
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_SECURITY_LOCKS_ITEM,
                  element: <IndividualCustomerSecurityLockForm type="locks" />,
                },
              ],
            },
            {
              path: ROUTES.CUSTOMERS_INDIVIDUAL_SECURITY_LOGS,
              element: <IndividualCustomerSecurityLogs />,
              children: [
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_SECURITY_LOGS_CREATE,
                  element: <IndividualCustomerSecurityLockForm type="logs" />,
                },
                {
                  path: ROUTES.CUSTOMERS_INDIVIDUAL_SECURITY_LOGS_ITEM,
                  element: <IndividualCustomerSecurityLogForm />,
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

export default IndividualCustomers;
